module.exports = __webpack_public_path__ + "static/pesonal_dev_logo2-ddd3789c1af91313b25df2676be31437.png";